import beneficiariesRoutes from "./beneficiaries/routes";
import discountRulesRoutes from "./discount-rules/routes";
import programsRoutes from "./programs/routes";
import programsFamiliesRoutes from "./programs-families/routes";
import registrationPoliciesRoutes from "./registration-policies/routes";
import transactionsRoutes from "./transactions/routes";
import tableauRoutes from "./tableau/routes";
import productsRoutes from "./products/routes";
import { IMenu, IRoute, RenderRoutes } from "@src/routes";
import { NavBar } from "@funcional/react-ui";
import { SsoRolesEnum } from "@funcional/react-auth-ui";
import { Redirect } from "react-router-dom";

const menus: IMenu[] = [
  {
    label: "PBM 2.0",
    path: "/pbm",
    roles: [
      SsoRolesEnum.MASTER,
      SsoRolesEnum.INDUSTRY,
      SsoRolesEnum.SUPPORT,
      SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
      SsoRolesEnum.RETAIL_PHARMA_BENEFIT_MANAGER,
    ],
    routes: [
      {
        label: "Programas",
        path: "/pbm/programs",
        roles: [
          SsoRolesEnum.MASTER,
          SsoRolesEnum.SUPPORT,
          SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
          SsoRolesEnum.RETAIL_PHARMA_BENEFIT_MANAGER,
        ],
      },
      {
        label: "Beneficiários",
        path: "/pbm/beneficiaries",
        roles: [
          SsoRolesEnum.MASTER,
          SsoRolesEnum.SUPPORT,
          SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
        ],
      },
      {
        label: "Pré-Transações",
        path: "/pbm/pre-transactions",
        roles: [
          SsoRolesEnum.MASTER,
          SsoRolesEnum.SUPPORT,
          SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
        ],
      },
      {
        label: "Transações Confirmadas",
        path: "/pbm/transactions",
        roles: [
          SsoRolesEnum.MASTER,
          SsoRolesEnum.SUPPORT,
          SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
        ],
      },
      {
        label: "Transações Inválidas",
        path: "/pbm/failed-transactions",
        roles: [
          SsoRolesEnum.MASTER,
          SsoRolesEnum.SUPPORT,
          SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
        ],
      },
      {
        label: "Políticas Cadastrais",
        path: "/pbm/registration-policies",
        roles: [
          SsoRolesEnum.MASTER,
          SsoRolesEnum.SUPPORT,
          SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
        ],
      },
      {
        label: "Produtos",
        path: "/pbm/products",
        roles: [
          SsoRolesEnum.MASTER,
          SsoRolesEnum.SUPPORT,
          SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
        ],
      },
      {
        label: "Dashboard",
        path: "/pbm/dashboard",
        roles: [
          SsoRolesEnum.MASTER,
          SsoRolesEnum.INDUSTRY,
          SsoRolesEnum.SUPPORT,
          SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
          SsoRolesEnum.RETAIL_PHARMA_BENEFIT_MANAGER,
        ],
      },
    ],
  },
];

const routes: IRoute[] = [
  {
    menu: { label: "Programas de Desconto" },
    path: "/pbm",
    key: "PBM",
    component: (props: any) => (
      <div className="w-full md:flex">
        <NavBar menus={menus} />
        <div className="flex-1 p-8 overflow-x-hidden overflow-y-auto">
          <RenderRoutes {...props} />
        </div>
      </div>
    ),
    routes: [
      {
        path: "/pbm/",
        key: "PBM_ROOT",
        exact: true,
        component: () => <Redirect to="/pbm/programs" />,
      },
      ...registrationPoliciesRoutes,
      ...beneficiariesRoutes,
      ...discountRulesRoutes,
      ...transactionsRoutes,
      ...programsRoutes,
      ...programsFamiliesRoutes,
      ...productsRoutes,
      ...tableauRoutes,
    ],
  },
];

export default routes;
